
import './App.css';
import React, { Component } from 'react'; //different
import instance from "./axios-instance";
import Systems from "./SystemFunction";

class Main extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pathname: "",
            linelink: ""
        }
    }
    async componentDidMount() {
        this.setState({
            pathname: window.location.pathname.replace("/", "").trim()
        });
        await instance.post("/api/v1/mainsetting", {
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                this.setState({
                    linelink: datas[1].value
                });
            }
            else {
                // this.CheckThisGoalError();
            }
        });
    }
    render() {
        const pathname = this.state.pathname
        return (
            <div className="x-menu-provider js-tab-menu-provider -desktop-view">
              
            </div>
        );
    }
}
export default Main;

